{
  "name": "Fruit Smasher Button",
  "powerupName": "FruitSmasher",
  "levelUpDescriptions": [
    "FruitSmasherUpgradeDescription1",
    "FruitSmasherUpgradeDescription2",
    "FruitSmasherUpgradeDescription3",
    "FruitSmasherUpgradeDescription4",
    "FruitSmasherUpgradeDescription5"
  ]
}